import React from 'react'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { useCmsBlock } from 'lib/core/hooks'
import { Wrapper } from './styled'

export const TwoColumns = () => {
  const blockId = CMS_BLOCK.PPL_FEATURED
  const columnsContent = useCmsBlock({
    id: blockId
  })

  if (!columnsContent.content) return null
  return (
    <Wrapper
      dangerouslySetInnerHTML={{
        __html: columnsContent.content
      }}
    />
  )
}
